module.exports = __webpack_public_path__ + "static/media/bfile-landlord.e1c15e09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-landlord.svg
// module id = 564
// module chunks = 0